import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { AppUpdateService } from 'src/app/services/app-update/app-update.service';

/** "Crystal was updated" prompt shown when a lazy chunk is gone after a deploy. One button: Reload. */
@Component({
  selector: 'update-prompt',
  imports: [DxPopupModule, DxButtonModule],
  template: `
    <dx-popup
      [visible]="update.visible()"
      [showTitle]="true"
      title="Crystal was updated"
      [width]="380"
      [height]="'auto'"
      [dragEnabled]="false"
      [hideOnOutsideClick]="false"
      [showCloseButton]="false"
      [shading]="true">
      <p>A new version of Crystal is available. Reload to continue.</p>
      <div style="display: flex; justify-content: flex-end; padding-top: 8px;">
        <dx-button text="Reload" type="default" (onClick)="update.reload()" />
      </div>
    </dx-popup>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppUpdatePromptComponent {
  readonly update = inject(AppUpdateService);
}
